interface GenerateThresholdStatusProps {
    thresholds: {
        thresholdOperator: 'lessThan' | 'greaterThan';
        warningThreshold: number;
        alertThreshold: number;
        value?: number;
    }[];
}

export const generateThresholdStatus = (props: GenerateThresholdStatusProps) => {
    const thresholdTriggers = props.thresholds.map((threshold) => {
        const { value, thresholdOperator, alertThreshold, warningThreshold } = threshold;
        if (value === undefined) return;
        if (value === null) return;

        if (thresholdOperator === 'lessThan') {
            if (value <= alertThreshold) return 2;
            if (value <= warningThreshold) return 1;
        }
        if (thresholdOperator === 'greaterThan') {
            if (value >= alertThreshold) return 2;
            if (value >= warningThreshold) return 1;
        }
        return 0;
    });

    if (thresholdTriggers.some((t) => t === undefined)) return;
    const thresholdNumbers = thresholdTriggers.filter((t): t is 0 | 1 | 2 => t !== undefined);
    if (thresholdNumbers.length < props.thresholds.length) return; // one of the threshold results is not defined

    const lowestRisk = Math.min(...thresholdNumbers); // Using min is what makes this an AND operation. Max would be an OR operation.
    return thresholdNumberToStatus(lowestRisk);
};
const thresholdNumberToStatus = (thresholdNumber: number) => {
    if (thresholdNumber === 2) return 'alert';
    if (thresholdNumber === 1) return 'warning';
    return 'good';
};

export const getThresholdOperator = (thresholdOperator: string) => {
    return thresholdOperator === 'lessThan' ? '≤' : '≥';
};
